import { setResources } from "./bootstrapResources";
import serverReference from "./serverReference-en-US.json";
import resources from "./translations-en-US.json";

setResources(resources, serverReference);